<template>
  <div class=" mx-auto" :class="backgroundClass ">
  <MainNavbar></MainNavbar>

    <router-view></router-view>

  <MainComponent></MainComponent>
  </div>
</template>

<script>
import MainNavbar from './components/Navbar.vue'
import MainComponent from './components/MainCommponent.vue'




export default {
  name: 'App',
  components: {
    MainNavbar,
    MainComponent,
  },
  computed: {
    backgroundClass() {
      // Check if the current route has the meta field 'hasBackgroundImage'
      return this.$route.meta.hasBackgroundImage ? 'bodyBck' : 'defaultBackground';
    }
  }
}
</script>

<style>
body{
 font-family: "Montserrat", sans-serif;
}
.defaultBackground{
  background-image: url('https://cdn.builder.io/api/v1/image/assets/TEMP/e122b98864ba52164a39350d25119e89e1dc1a48f30ebede8711dbd1874bac04?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.bodyBck  {
  background-color: #0F0E0E;
}
</style>



<!--  -->

